import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';
import { studentFeesConsumerStudentsFeesKeys } from './fees/keys';
import { studentFeesConsumerStudentsPaymentsKeys } from './payments/keys';

const studentFeesConsumerStudentsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'students'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...key, uuid] as const,
        detail: [...key, uuid, 'detail'] as const,
        fees: studentFeesConsumerStudentsFeesKeys([...key, uuid]),
        payments: studentFeesConsumerStudentsPaymentsKeys([...key, uuid]),
      }),
  });
};

export { studentFeesConsumerStudentsKeys };
